module.exports = __webpack_public_path__ + "static/media/arrow-down-blue.5394b099.svg";